module.exports = __webpack_public_path__ + "static/media/quick-setup.6ddc5f74.png";